import React from 'react';
import { Avatar, IAvatarProps } from '../Avatar/Avatar';
import AUS from '../../assets/flags/4x3/aus.svg';
import BEL from '../../assets/flags/4x3/bel.svg';
import CAN from '../../assets/flags/4x3/can.svg';
import CHE from '../../assets/flags/4x3/che.svg';
import DEU from '../../assets/flags/4x3/deu.svg';
import DNK from '../../assets/flags/4x3/dnk.svg';
import ESP from '../../assets/flags/4x3/esp.svg';
import FRA from '../../assets/flags/4x3/fra.svg';
import GBR from '../../assets/flags/4x3/gbr.svg';
import HKG from '../../assets/flags/4x3/hkg.svg';
import JPN from '../../assets/flags/4x3/jpn.svg';
import NLD from '../../assets/flags/4x3/nld.svg';
import NZL from '../../assets/flags/4x3/nzl.svg';
import SGP from '../../assets/flags/4x3/sgp.svg';
import SWE from '../../assets/flags/4x3/swe.svg';
import USA from '../../assets/flags/4x3/usa.svg';
import { useTestId } from '../../hooks/useTestId';

export enum Exchanges {
  Aus = 'AUS',
  Bel = 'BEL',
  Can = 'CAN',
  Che = 'CHE',
  Deu = 'DEU',
  Dnk = 'DNK',
  Esp = 'ESP',
  Fra = 'FRA',
  Gbr = 'GBR',
  Hkg = 'HKG',
  Jpn = 'JPN',
  Nld = 'NLD',
  Nzl = 'NZL',
  Sgp = 'SGP',
  Swe = 'SWE',
  Usa = 'USA'
}

export const flags: { [k in Exchanges]: any } = {
  AUS,
  BEL,
  CAN,
  CHE,
  DEU,
  DNK,
  ESP,
  FRA,
  GBR,
  HKG,
  JPN,
  NLD,
  NZL,
  SGP,
  SWE,
  USA
};

export interface IExchangeFlagProps extends Pick<IAvatarProps, 'size' | 'bordered' | 'glow'> {
  exchange: Exchanges;
}

export const ExchangeFlag: React.FC<IExchangeFlagProps> = ({ exchange, ...rest }) => {
  const { generateTestId } = useTestId(rest, `ExchangeFlags--${exchange}`);

  return <Avatar img={flags[exchange]} {...generateTestId()} {...rest} />;
};
